import React from 'react';
import AbilityTargeting from './AbilityTargeting';
import OptionsSelect from './OptionsSelect';

function ActivePromptControls({ controls, buttons, onMouseOver, onMouseOut, onOptionSelected }) {
    return controls.map((control) => {
        switch (control.type) {
            case 'targeting':
                return (
                    <AbilityTargeting
                        key='targeting'
                        onMouseOut={onMouseOut}
                        onMouseOver={onMouseOver}
                        source={control.source}
                        targets={control.targets}
                        trigger={control.trigger}
                    />
                );
            case 'options-select':
                return (
                    <OptionsSelect
                        key='options-select'
                        options={buttons}
                        onOptionSelected={onOptionSelected}
                    />
                );
            default:
                return null;
        }
    });
}

export default ActivePromptControls;